import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "section"]

  connect() {
    const savedTab = this.readStoredTab()
    const initialTab = savedTab || "manage"
    this.activateTab(initialTab)
    this.restoreCollapsedSections()
  }

  switch(event) {
    const tabName = event.currentTarget.dataset.tab
    if (!tabName) return
    this.activateTab(tabName)
    this.storeTab(tabName)
  }

  activateTab(tabName) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName
      tab.classList.toggle("is-active", isActive)
      tab.setAttribute("aria-selected", isActive ? "true" : "false")
      tab.setAttribute("tabindex", isActive ? "0" : "-1")
    })

    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.tab === tabName
      panel.classList.toggle("is-active", isActive)
      panel.setAttribute("aria-hidden", isActive ? "false" : "true")
    })
  }

  readStoredTab() {
    try {
      return window.localStorage.getItem("sidebar.activeTab")
    } catch (error) {
      return null
    }
  }

  storeTab(tabName) {
    try {
      window.localStorage.setItem("sidebar.activeTab", tabName)
    } catch (error) {
      // Ignore storage failures (private mode / blocked storage)
    }
  }

  toggleSection(event) {
    const button = event.currentTarget
    const section = button.closest("[data-sidebar-target='section']")
    if (!section) return

    const sectionName = section.dataset.section
    const isCollapsed = section.classList.toggle("is-collapsed")
    this.storeCollapsedState(sectionName, isCollapsed)
  }

  restoreCollapsedSections() {
    const collapsed = this.readCollapsedSections()
    this.sectionTargets.forEach((section) => {
      const sectionName = section.dataset.section
      if (collapsed.includes(sectionName)) {
        section.classList.add("is-collapsed")
      }
    })
  }

  readCollapsedSections() {
    try {
      const stored = window.localStorage.getItem("sidebar.collapsedSections")
      return stored ? JSON.parse(stored) : []
    } catch (error) {
      return []
    }
  }

  storeCollapsedState(sectionName, isCollapsed) {
    try {
      let collapsed = this.readCollapsedSections()
      if (isCollapsed) {
        if (!collapsed.includes(sectionName)) {
          collapsed.push(sectionName)
        }
      } else {
        collapsed = collapsed.filter((name) => name !== sectionName)
      }
      window.localStorage.setItem("sidebar.collapsedSections", JSON.stringify(collapsed))
    } catch (error) {
      // Ignore storage failures
    }
  }
}
